import { Injectable } from '@angular/core';
import Excel, { Buffer } from 'exceljs';
import { SLLayer, LayerAccessLevel } from 'src/app/model/sl-layer';
import { SLMap } from 'src/app/model/sl-map';

import { ColumnFormatter } from 'src/app/model/formatters/columnformatter';
import { AttributesService } from 'src/app/model/api-services/attributes.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { SimpleFunction, AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { DateQualifierService } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';
import { NumberFractionQualifierService } from 'src/app/model/api-services/qualifiers/number-fraction-qualifier.service';
import { GeoLocationQualifierService } from 'src/app/model/api-services/qualifiers/geo-location-qualifier-service';

declare const Slick: any;

@Injectable({
  providedIn: 'root'
})
export class ExcelIoService {

  constructor() {


  }
  public static ExportData(messager: ModalMessagerService,
    data: any, columnIds: Array<string>, layer: SLLayer, customMetaDataProvider: SimpleFunction,/*moment: ResultMoment,*/
    rawMode: boolean = true, includeMap: boolean = true, grouped: boolean) {

    const map: SLMap = layer.map as SLMap;
    const slippyMap = map.ui;

    const width = slippyMap.width;
    const height = slippyMap.height;
    const wb = new Excel.Workbook();
    // const momentLayer: any = XLSExportService.GetMomentLayer(layer, moment);

    if (includeMap === true) {
      const mapURL = slippyMap.getCanvas().toDataURL();
      const sheet = wb.addWorksheet('Map - ' + layer.SLMap.project.name.replace(/[\[\]\*\?\:\\\/]/g, ' '), {
        pageSetup: {
          paperSize: 5,
          orientation: 'portrait',
          fitToPage: true,
          fitToWidth: 1
        }
      });
      const mapImageId = wb.addImage({
        base64: mapURL,
        extension: 'png',
      });
      sheet.addImage(mapImageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 96 * (7.5), height: 96 * (7.5) * (slippyMap.getContainer().offsetHeight / slippyMap.getContainer().offsetWidth) }
      });
    }

    const sheet2 = wb.addWorksheet('Data - ' + layer.name.replace(/[\[\]\*\?\:\\\/]/g, ' '), {
      pageSetup: {
        paperSize: 5,
        orientation: 'portrait',
        fitToPage: true,
        fitToWidth: 1
      }
    });

    const colIndex = {};
    let i = -1;
    for (var columnId of columnIds) {
      i += 1;
      colIndex[columnId] = i;
    }

    const columns = [];
    const attMap: any = {}
    const headerRow = [];
    for (const attribute of layer.layerAttributes) {
      if (!AttributesService.IsVisible(attribute)) {
        continue;
      }
      if (columnIds.indexOf(attribute.name) < 0) {
        continue;
      }
      if (attribute.export) {
        if (attribute.export.allow === false) {
          continue;
        }
        if (attribute.export.reqAuth === true) {
          if (layer.access < LayerAccessLevel.Copy) {
            continue;
          }
        }
      }
      attMap[attribute.name] = attribute;
      columns[colIndex[attribute.name]] = attribute;

    }
    //ExportService.SetupColumns(layer, columns, momentLayer.fields, true);

    const excelColumns = [];
    if (grouped === true) {
      excelColumns.push({
        header: '',
        key: '__column_name__',
        width: 10,
      });
    }

    for (const column of columns) {
      if (column === -1) { continue; }
      excelColumns.push({
        header: column.display,
        key: column.name,
        width: column.display.length + 5,


      });
    }
    sheet2.columns = excelColumns;

    // sheet2.addRow(columns);

    messager.Progress('Processing Data', false, 0, 'Exporting Data');
    let r = 0;
    for (const item of data) {
      r += 1;
      messager.Progress(`Processing Data - Record ${r} of ${data.length}`, false, r / data.length, 'Exporting Data');

      if (item instanceof Slick.NonDataRow) {
        if (!((item as any).__custom)) {
          let title = (item as any).title;
          if (title.indexOf('<') > -1) {
            title = title.replace(/<[^>]+>([^<]+)<.+/gi, '$1');
          }
          sheet2.addRow({ __column_name__: title });
          continue;
        }
        const rowProvider = customMetaDataProvider(item);
        const rowOptions = rowProvider.getOptions();
        const rowMetaData = rowProvider.getRowMetadata();
        if (rowMetaData.columns && rowMetaData.columns[0]) {
          {
            // Group title
            if (rowOptions.columns[0].colspan === '*') {
              const groupRecord = { __column_name__: rowOptions.columns[0].xlsFormatter(item, attMap) };
              const groupRow = sheet2.addRow(groupRecord);
            }
          }
          continue;
        }

        const groupRecord: any = {};
        if (columnIds[0] !== '_sl_actions_') {
          groupRecord.__column_name__ = rowOptions.xlsFormatter(item, { name: 'gid' })
        }
        groupRecord.__column_name = '';
        for (const col of columnIds) {

          if (col === '_checkbox_selector') {
            continue;
          }
          if (col === '_sl_actions') {
            continue;
            // groupRecord.__column_name__ = rowOptions.xlsFormatter(item, { name: 'gid' })
          } else {
            groupRecord[col] = rowOptions.xlsFormatter(item, attMap[col], rawMode);
          }

        }
        const groupRecordRow = sheet2.addRow(groupRecord);
        let i = 1;
        for (const groupColumn of columns) {
          i += 1;
          const cell = groupRecordRow.getCell(i);
          if (!!item.aggName) {
            switch (item.aggName) {
              case 'count':
                if (cell.model.value === '') {
                  cell.model.type = Excel.ValueType.String;
                  cell.numFmt = '@';
                  continue;
                }
                cell.model.type = Excel.ValueType.Number;
                cell.numFmt = '#,##0';
                break;
              case 'stddev':
                if (cell.model.value === '') {

                  continue;
                }
                cell.model.type = Excel.ValueType.Number;
                cell.numFmt = '#,0.????';
              default:
                {
                  const att: AttributeInfo = attMap[groupColumn.name];
                  let casting: CastingValue = null;
                  if (!!att.casting && !!att.casting.display) {
                    casting = att.casting.display;
                  } else if (!!att.casting && !!att.casting.entry) {
                    casting = att.casting.entry;
                  }
                }

            }
          }
        }


        continue;
      }



      const record: any = {}
      if (grouped === true) {
        record.__column_name__ = '';
      }
      for (const col of columns) {
        record[col.name] = item[col.name];
      }
      const row = sheet2.addRow(record);
      if (rawMode === true) {
        continue;
      }
      let i = (!!grouped) ? 1 : 0;
      for (const column of columns) {
        i += 1;

        const cell = row.getCell(i);
        const att: AttributeInfo = attMap[column.name];
        let casting: CastingValue = null;
        if (!!att.casting && !!att.casting.display) {
          casting = att.casting.display;
        } else if (!!att.casting && !!att.casting.entry) {
          casting = att.casting.entry;
        }

        let val = record[column.name];
        if ([null, NaN, 'null', 'NaN', undefined, null, ''].indexOf(val) > -1) {
          continue;
        }

        let txt = ColumnFormatter.FormatText(item, attMap[column.name]); //AttributesService.GetDisplayValue(attMap[column.name], val, true);
        if (txt === null) {
          txt = '';
          val = '';
        }
        const effType = AttributesService.GetEffectiveType(attMap[column.name]);
        let checkEffType = true;
        if (!!casting && !!casting.geoLocPart) {
          checkEffType = false;
          if (casting.geoLocPart) {
            switch (casting.geoLocPart) {
              case 'lattitude':
              case 'longitude':
                switch (map.globalLatLonDefault) {
                  case 'ddeg':
                    cell.model.type = Excel.ValueType.Number
                    cell.numFmt = GeoLocationQualifierService.GetNumFormat('ddeg');
                    break;
                  case 'deg-min-sec':
                    cell.model.type = Excel.ValueType.Formula
                    const degResult = val;
                    cell.value = {
                      formula: `TEXT(TRUNC(${degResult}), "0" & CHAR(176) & " ") & TEXT(INT((ABS(${degResult})
- INT(ABS(${degResult})))*60), "0' ") & TEXT(((((ABS(${degResult})-INT(ABS(${degResult})))*60) - INT((ABS(${degResult}) - INT(ABS(${degResult})))*60))*60), " 0''")`,
                      date1904: false
                    }
                    cell.numFmt = '@'; //GeoLocationQualifierService.GetNumFormat('deg-min-sec');
                    // tslint:disable-next-line: max-line-length
                    break;
                }
                break;
              case 'heading':
                cell.numFmt = GeoLocationQualifierService.GetNumFormat('ddeg') + ` E`;
                cell.value = val;
                cell.model.type = Excel.ValueType.Number;
                break;
              default:
                cell.model.type = Excel.ValueType.Number
                if (val === '') {
                  val = '0';
                }
                cell.value = val;

                if (Number.isInteger(val)) {
                  cell.numFmt = '#,0';
                } else {
                  cell.numFmt = '#,0.00000';
                }


            }
          }
        }

        let attType = effType.attType;
        if (txt === '') {
          attType = 'text';
        }
        if (checkEffType === true) {
          switch (effType.effValType) {
            case 'boolean':
              cell.model.type = Excel.ValueType.Boolean;
              cell.model.text = txt;
              cell.model.value = val;
              break;
            case 'url':
            case 'cg_url':
              cell.model.type = Excel.ValueType.Hyperlink;
              cell.model.hyperlink = val;
              cell.model.text = txt;
              cell.model.value = txt;
              break;
            case 'date':
              cell.model.type = Excel.ValueType.Date;
              if (val instanceof Date) {
                cell.model.value = val;//.toISOString();
              } else {
                cell.model.value = new Date(val);//.toISOString();
              }
              if (casting === null) {
                // do nothing
              } else {
                cell.numFmt = DateQualifierService.GetNumFormat(attMap[column.name], 'display');
              }

              break;
            case 'number':
              cell.model.type = Excel.ValueType.Formula;
              //cell.model.value = Number(val);
              // cell.model.text = txt;

              if (!!casting && !!casting.fractional) {
                cell.value = {
                  formula: `${val}/${casting.fractional.denom}`,
                  result: NumberFractionQualifierService.GetXlsNum(attMap[column.name], 'display', Number(val)),
                  date1904: false
                };
                const fractionNote = `Original Value: ${val}. Use ${cell.address} * ${casting.fractional.denom} for original value`;
                cell.note = fractionNote;
              } else {
                cell.value = Number(val);
              }
              cell.numFmt = NumberQualifierService.GetNumFormat(attMap[column.name], 'display');

              break;
            case 'string':
            case 'text':
              cell.model.type = Excel.ValueType.String;
              cell.model.value = val;
              cell.model.text = txt;
              break;
          }
        }
        if (!!txt) {
          excelColumns[i - 1].width = Math.max(excelColumns[i - 1].width, txt.length + 2);
        }
      }
      sheet2.columns = excelColumns;
    }
    wb.xlsx.writeBuffer({

    }).then((xlsBuffer: Buffer) => {
      const xls64 = (xlsBuffer as any);

      // build anchor tag and attach file (works in chrome)
      // const imgData = new Blob([xls64], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      //const url = URL.createObjectURL(imgData);
      // XLSExportService.s2ab(xlsData)
      messager.RequestExport(
        {
          extension: 'xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          contents: xls64, defaultFileName: 'ResultsFrom_' + layer.name.replace(/ /g, '_')
        },
        'Export results as ...',
        () => {
          messager.Cancel('Export results as ...');
          messager.Notify('Your file has been saved');
        }, () => {
          messager.Cancel('Export resutls as ...');
          messager.Notify('There was an unknown problem saving your file', true, 'Problem Saving');
        }
      );
    });
  }


}
